<template>
  <pre v-html="json">
  </pre>
</template>

<style>
pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }
.jsonstring { color: green; }
.jsonnumber { color: darkorange; }
.jsonboolean { color: blue; }
.jsonnull { color: magenta; }
.jsonkey { color: red; }
</style>

<script>
// http://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
function syntaxHighlight (json) {
  if (!json) {
    return ''
  }

  // format json using stringify
  if (typeof json === 'string') {
    json = JSON.parse(json)
  }
  json = JSON.stringify(json, undefined, 2)

  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var cls = 'number'
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key'
      } else {
        cls = 'string'
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean'
    } else if (/null/.test(match)) {
      cls = 'null'
    }
    return '<span class="' + 'json' + cls + '">' + match + '</span>'
  })
}

export default {
  props: [ 'jsonObject' ],

  computed: {
    json () {
      return syntaxHighlight(this.jsonObject)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Json.vue?565da596